/**
 * Hero renderer.
 *
 * Pulls the name + dek/tagline from the content module and populates
 * the corresponding elements in the static markup. The name is split
 * on whitespace into stacked lines (e.g. "Senna Grey" -> "Senna" /
 * "Grey") so it can be set in the largest possible size without
 * forcing an awkward break.
 *
 * The hero h1 still contains the full name as text in the markup for
 * SEO and accessibility — this function just wraps each whitespace
 * token in a <span> for styling, leaving the underlying text intact.
 */

import { site } from './data/content.js';

function splitNameIntoLines(name) {
  // Split on whitespace, drop empties, wrap each in a span.
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((token) => `<span class="hero_name-line">${token}</span>`)
    .join('');
}

function applyTagline(target, lede, payoff) {
  if (!target) return;
  // Lede is rendered in italic; payoff in roman. The em/em-marked
  // first sentence is the italic part.
  target.innerHTML = `<em>${lede}</em> ${payoff}`;
}

export function renderHero() {
  const nameTarget = document.querySelector('#hero .hero_name');
  if (nameTarget) {
    nameTarget.innerHTML = splitNameIntoLines(site.name);
  }

  const dekTarget = document.querySelector('#hero .hero_dek');
  if (dekTarget && site.hero?.dek) {
    dekTarget.textContent = site.hero.dek;
  }

  const taglineTarget = document.querySelector('#hero .hero_tagline');
  if (taglineTarget && site.hero?.lede && site.hero?.payoff) {
    applyTagline(taglineTarget, site.hero.lede, site.hero.payoff);
  }
}
